<template>
  <div
    class="component-mask-selector-quiz-form"
    resmed-component-name="mask-selector-quiz-form"
  >
    <div class="component">
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <h1>Want your CPAP mask recommendations?</h1>
            <p>
              Complete the form to unlock your mask results. They’ll be sent to
              your Inbox too.
            </p>
          </div>
        </div>

        <form action="javascript:" v-on:submit.prevent="submit" class="mt-5">
          <div class="row">
            <div class="col">
              <div class="d-md-flex">
                <div class="group pr-md-2">
                  <label>First name</label>
                  <input
                    type="text"
                    placeholder="John"
                    ref="firstname"
                    v-model="fields.firstname"
                    v-bind:class="{
                      'validation -invalid': validation.firstname,
                    }"
                    tabindex="1"
                    @focus="validation.firstname = null"
                  />
                  <div
                    v-if="validation.firstname"
                    v-on:click="setfocus('firstname')"
                    class="error-message"
                  >
                    {{ validation.firstname[0] }}
                  </div>
                </div>
                <div class="group pl-md-2">
                  <label>Last name</label>
                  <input
                    type="text"
                    placeholder="Smith"
                    ref="lastname"
                    v-model="fields.lastname"
                    v-bind:class="{
                      'validation -invalid': validation.lastname,
                    }"
                    tabindex="2"
                    @focus="validation.lastname = null"
                  />
                  <div
                    v-if="validation.lastname"
                    v-on:click="setfocus('lastname')"
                    class="error-message"
                  >
                    {{ validation.lastname[0] }}
                  </div>
                </div>
              </div>
              <div class="d-md-flex">
                <div class="group pr-md-2">
                  <label>Email</label>
                  <input
                    type="text"
                    placeholder="smith@example.com"
                    ref="email"
                    v-model="fields.email"
                    v-bind:class="{ 'validation -invalid': validation.email }"
                    tabindex="3"
                    @focus="validation.email = null"
                  />
                  <div
                    v-if="validation.email"
                    v-on:click="setfocus('email')"
                    class="error-message"
                  >
                    {{ validation.email[0] }}
                  </div>
                </div>
                <div class="group pl-md-2">
                  <label>Country</label>
                  <select
                    v-model="fields.country"
                    ref="country"
                    v-on:change="
                      validation.country && (validation.country[0] = null)
                    "
                    tabindex="4"
                  >
                    <option>United States</option>
                    <option>Canada</option>
                  </select>
                  <div v-if="validation.country" class="-validation">
                    {{ validation.country[0] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col text-center">
              <div class="group px-md-7">
                <input
                  type="checkbox"
                  class="ui-white"
                  v-model="fields.optin"
                  id="optin"
                />
                <label for="optin"
                  >Please add me to the ResMed community so I can receive ResMed
                  product and marketing information. I understand that if I
                  change my mind, I can opt out at any time.
                  <a href="/privacy/" target="_blank">Privacy Policy</a>.</label
                >
              </div>
              <div v-if="!status.complete" style="position: relative">
                <button
                  type="submit"
                  class="btn cta-pill filled-red icon right-arrow"
                  :disabled="status.idle"
                >
                  Get your results
                </button>
              </div>
              <div class="py-3">
                <div v-if="status.idle" class="spinner"></div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import wpApi from "../../services/wpApi";
let fillable = {
  firstname: "",
  lastname: "",
  email: "",
  country: "United States",
  optin: true,
};

export default {
  name: "component-mask-selector-quiz-form", // mask-selector-quiz-form
  data() {
    return {
      fields: { ...fillable },
      validation: {},
      response: {
        type: "", // validation or confirmation
        message: "", // response
      },
      status: {
        idle: null,
        complete: false,
      },
    };
  },
  watch: {
    "fields.country"(val) {
      this.fields.optin = val !== "Canada";
    },
  },
  methods: {
    reset() {
      return (this.fields = {
        ...fillable,
      });
    },
    setfocus(arg) {
      this.validation[arg] = null;
      this.$refs[arg].focus();
    },
    submit(event) {
      let data = new FormData();

      for (let prop in this.fields) {
        data.append(prop, this.fields[prop]);
      }

      // on before send
      axios.interceptors.request.use((config) => {
        this.status.idle = true;
        this.response.message = "";
        this.validation = {};

        return config;
      });

      wpApi.submitMaskSelectorQuizForm(data).then((response) => {
        let data = response.data;

        this.status.idle = null;

        if ("validation" in data) {
          this.response.type = "validation";
          this.validation = data.validation;
        }

        if ("confirmation" in data) {
          this.response.type = "confirmation";
          this.status.idle = true; // switch to true. wait for redirect to take place.
          window.location.href = data.confirmation; // redirect to the results page.
        }

        if ("error" in data) {
          this.response.type = "error";
          this.response.message = data.error;
        }

        if ("confirmation" in data || "error" in data) {
          this.status.complete = true;
          // this.reset(); // reset all form fields
        }
      });
    },
  },
  mounted() {
    this.$set(this.fields, "results", JSON.stringify(this.$parent.results)); // recommended masks and data
    this.$set(this.fields, "answers", JSON.stringify(this.$parent.answers)); // quiz answers/responses
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/base/utilities";

.component-mask-selector-quiz-form {
  //
}

.component {
  padding: 2rem 0 0 0;

  @media (min-width: 768px) {
    padding: 0;
  }

  // display: flex;
  // justify-content: center;

  > .container {
    @media (min-width: 992px) and (max-width: 1199px) {
      max-width: 720px;
    }
  }

  h1 {
    margin-bottom: 1.75rem;
    font-size: 2.25rem;

    @media (min-width: 768px) {
      padding-top: 8.5rem;
      background-size: 7rem;
      background-position: center top;
      background-repeat: no-repeat;
      background-image: url(#{$assets}/images/sleep-apnea--mask-selector--icon@2x.png);
    }

    + p {
      margin: 0 auto;
      @media (min-width: 992px) {
        max-width: 380px;
      }
    }
  }

  h1,
  p {
    color: $cc-resmed-white;
  }

  form {
    > .row {
      @media (min-width: 1200px) {
        margin: 0 auto;
        max-width: 776px;
      }
    }

    label {
      text-align: left;
      color: $cc-resmed-white;
    }

    [for="optin"] {
      margin: 1rem auto;
      @extend %body-x-small;

      a {
        &:hover,
        &:focus {
          color: $cc-resmed-white;
        }
      }
    }

    select {
      background-color: $cc-resmed-white;
    }

    .spinner {
      margin: 0 auto;
      border-left-color: $cc-resmed-white;
    }

    .error-message {
      cursor: text;
      border: 2px solid #dd2726;
      background-color: $cc-resmed-white;
      position: relative;
      border-radius: 6px;
    }

    .-invalid {
      border: none !important;
    }

    .-validation {
      @extend %body-small-bold;
      text-align: right;
      color: $cc-resmed-white;
    }

    .group {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 50%;
    }
  }
}
</style>